import React, { Component } from 'react';
import WebMercatorViewport from 'viewport-mercator-project';
import MapTooltip from '../map-tooltip';
import styles from './search-map-container.module.scss';
import './mapbox.scss';
import ReactMapGL, { SVGOverlay } from 'react-map-gl';
import { connect } from 'react-redux';
import { getQldCouncilsGeo, getIsMobile, getRegions } from '../../reducers';
import { findDOMNode } from 'react-dom';
import { parse as SvgParser } from 'svg-parser';
import geojson2svg from 'geojson-to-svg';
import { geoJsonFilePath } from '../../config';

const DEFAULT_COORDINATES = [-20, 146];
const COLOR_BLUE = 'rgb(200, 204, 230)';
const COLOR_HIGHLIGHT = '#6a74c4';
const BBOX = [
  137.994324998,
  -29.1778726869999,
  153.552171248,
  -9.21993695299994,
];
const minZoom = 3.895055500278351;
const initialViewport = {
  latitude: DEFAULT_COORDINATES[0],
  longitude: DEFAULT_COORDINATES[1],
  zoom: 4.3,
  width: 200,
  height: 600,
};

const getPathObjects = ({ project, feature }) => {
  const svgString = geojson2svg()
    .projection(project)
    .data(feature)
    .render();
  const svgObj = SvgParser(svgString);
  const gObj = svgObj.children[0];
  const pathObjs = gObj.children;

  return pathObjs;
};

class SearchMapContainer extends Component {
  constructor() {
    super();
    this.state = {
      hoveredCouncil: null,
      tooltipPosition: { x: 0, y: 0 },
      viewState: initialViewport,
      qldCouncilsGeo: null,
      regions: null
    };
  }
  componentDidMount() {
    var { width, height } = findDOMNode(this.map).getBoundingClientRect();
    fetch(`${process.env.PUBLIC_URL}/${geoJsonFilePath}`)
      .then(x => x.json())
      .then(json => this.setState({ qldCouncilsGeo: json }))
      .then(x => {
        const viewState = new WebMercatorViewport({ width, height }).fitBounds([
          BBOX.slice(0, 2),
          BBOX.slice(2, 4),
        ]);
        this.setState({ viewState });
      });
  }

  render() {
    const { hoveredCouncil, tooltipPosition, qldCouncilsGeo } = this.state;
    const { isMobile, regions } = this.props;
    return (
      <div
        ref={d => {
          this.map = d;
        }}
        className={`searchMapWrapper ${styles.searchMapWrapper}`}
      >
        <ReactMapGL
          scrollZoom={false}
          dragPan={isMobile}
          dragRotate={false}
          doubleClickZoom={false}
          touchZoom={isMobile}
          touchRotate={false}
          onViewportChange={viewState => this.setState({ viewState })}
          initialViewState={initialViewport}
          viewState={this.state.viewState}
          width={'100%'}
          height={'100%'}
          mapStyle={{
            version: 8,
            name: 'Basic',
            sources: {
              neighbours: {
                type: 'geojson',
                data: `${process.env.PUBLIC_URL}/data/neighbours.geo.json`,
              },
            },
            layers: [
              {
                id: 'neighbour-layer',
                type: 'fill',
                source: 'neighbours',
                paint: {
                  'fill-color': 'rgb(235, 235, 246)',
                },
              },
            ],
          }}
        >
          <SVGOverlay
            redraw={({ project }) => {
              if (!qldCouncilsGeo) return null;
              const nameSelector = x => x.properties.LGA_NAME_2016;
              return qldCouncilsGeo.features.map((x, i) => {
                const pathObjs = getPathObjects({ project, feature: x });
                const active = nameSelector(x) === hoveredCouncil;
                return (
                  <g key={nameSelector(x) + i}>
                    {pathObjs.map((path, i) => {
                      return (
                        <path
                          onClick={() => {
                            if (!active) {
                              this.setState({
                                hoveredCouncil: nameSelector(x),
                              });
                            } else {
                              this.props.onCouncilSelect(regions.find(r => r.lgaName === nameSelector(x)).name);
                            }
                          }}
                          onMouseEnter={e => {
                            if (isMobile) return;
                            this.setState({ hoveredCouncil: nameSelector(x) });
                          }}
                          onMouseLeave={() =>
                            this.setState({ hoveredCouncil: null })
                          }
                          key={'fill' + i}
                          stroke="white"
                          strokeWidth="1"
                          fill={active ? COLOR_HIGHLIGHT : COLOR_BLUE}
                          style={{
                            cursor: 'pointer',
                          }}
                          d={path.attributes.d}
                        />
                      );
                    })}
                  </g>
                );
              });
            }}
          />
        </ReactMapGL>

        <div
          className={styles.navigationControls}
          style={{ position: 'absolute', right: 10, top: 10 }}
        >
          <div className="search-map-container-module__navigationControls___1LhXt">
            <div className="mapboxgl-ctrl mapboxgl-ctrl-group ">
              <button
                onClick={e =>
                  this.setState(state => ({
                    viewState: {
                      ...state.viewState,
                      zoom: state.viewState.zoom + 1,
                    },
                  }))
                }
                className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in"
                type="button"
                title="Zoom In"
              />
              <button
                onClick={e => {
                  const newZoom = this.state.viewState.zoom - 1;
                  if (newZoom < minZoom) return;
                  this.setState(state => ({
                    viewState: {
                      ...state.viewState,
                      zoom: newZoom,
                    },
                  }));
                }}
                className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out"
                type="button"
                disabled={this.state.viewState.zoom - 1 < minZoom}
                title="Zoom Out"
              />
            </div>
          </div>
        </div>
        <MapTooltip
          visible={Boolean(hoveredCouncil)}
          position={tooltipPosition}
          isStatic={true}
        >
          {hoveredCouncil}
        </MapTooltip>
      </div>
    );
  }
}

export default connect(s => ({
  qldCouncilsGeo: getQldCouncilsGeo(s),
  regions: getRegions(s),
  isMobile: getIsMobile(s),
}))(SearchMapContainer);



// WEBPACK FOOTER //
// ./src/components/search-map-container/search-map-container.js